import reportError from 'util/errorReporter';
import { createSelector } from 'reselect';
import Progress from 'redux-progress';

import { CHOOSE, SEARCH } from 'modules/addon/duck/model';
import selectChosenParentOption from 'modules/addon/duck/selectors/chosenParentOption';
import selectSearchParentOption from 'modules/addon/duck/selectors/searchParentOption';
import { TermOption } from 'model/TermOption';
import { Selector } from 'model/State';

const selectTerm: Selector<Progress<TermOption>> = createSelector(
  (state) => state.addon.mode,
  selectChosenParentOption,
  selectSearchParentOption,
  (mode, chosenParentProgress, searchParentProgress) => {
    switch (mode) {
      case CHOOSE:
        return chosenParentProgress.map((parent) => parent && parent.term);
      case SEARCH:
        return Progress.success(
          searchParentProgress.fold({
            success: (parent) => parent && parent.term,
          }),
        );
      default:
        reportError(`Unknown addon config mode ${mode}`);
        return Progress.none;
    }
  },
);

export default selectTerm;
